import { pb, getRestaurantId } from '../config/pocketbase';
import { supabase } from '../config/supabase';

// Flag per determinare se usare PocketBase o Supabase (default: PocketBase)
const USE_POCKETBASE = import.meta.env.VITE_USE_POCKETBASE !== 'false';

/**
 * Adapter Unificato per Operazioni Database (PocketBase 100% Free + Fallback Supabase)
 * Inietta automaticamente 'ristorante_id' su ogni comanda o modifica.
 */
export const dbAdapter = {
  getRestaurantId,

  /**
   * Crea una nuova comanda inviata dal cameriere o dal tavolo
   */
  async createComanda({ tavolo, piatti, status = 'attiva', codice_comanda, consegnata = false }) {
    const restaurantId = getRestaurantId();
    const payload = {
      tavolo: Number(tavolo),
      piatti: Array.isArray(piatti) ? piatti : [],
      status,
      codice_comanda: codice_comanda || Math.floor(1000 + Math.random() * 9000).toString(),
      consegnata: Boolean(consegnata),
      ristorante_id: restaurantId,
      timestamp: new Date().toISOString()
    };

    if (USE_POCKETBASE) {
      try {
        return await pb.collection('comande_tap2order').create(payload);
      } catch (pbError) {
        console.warn('[dbAdapter] Creazione PocketBase fallita, tentativo fallback Supabase:', pbError?.message);
      }
    }

    // Fallback Supabase
    const { data, error } = await supabase.from('comande_tap2order').insert([payload]).select().single();
    if (error) throw error;
    return data;
  },

  /**
   * Aggiorna lo stato o i dettagli di una comanda
   */
  async updateComanda(id, updates) {
    if (USE_POCKETBASE) {
      try {
        return await pb.collection('comande_tap2order').update(id, updates);
      } catch (pbError) {
        console.warn('[dbAdapter] Update PocketBase fallito, tentativo fallback Supabase:', pbError?.message);
      }
    }

    const { data, error } = await supabase.from('comande_tap2order').update(updates).eq('id', id).select().single();
    if (error) throw error;
    return data;
  },

  /**
   * Elimina una comanda
   */
  async deleteComanda(id) {
    if (USE_POCKETBASE) {
      try {
        return await pb.collection('comande_tap2order').delete(id);
      } catch (pbError) {
        console.warn('[dbAdapter] Delete PocketBase fallito, tentativo fallback Supabase:', pbError?.message);
      }
    }

    const { error } = await supabase.from('comande_tap2order').delete().eq('id', id);
    if (error) throw error;
    return true;
  },

  /**
   * Chiude un tavolo marcando tutte le comande come pagate
   */
  async closeTavolo(tableNumber, comandeIds = []) {
    if (!comandeIds || comandeIds.length === 0) return true;

    if (USE_POCKETBASE) {
      try {
        await Promise.all(
          comandeIds.map(id => pb.collection('comande_tap2order').update(id, { status: 'pagata' }))
        );
        return true;
      } catch (pbError) {
        console.warn('[dbAdapter] Chiusura tavolo PocketBase fallita, fallback Supabase:', pbError?.message);
      }
    }

    const { error } = await supabase
      .from('comande_tap2order')
      .update({ status: 'pagata' })
      .in('id', comandeIds);

    if (error) throw error;
    return true;
  }
};

export default dbAdapter;
